var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcBack24X24 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.505 3.514a.75.75 0 0 1 0 1.06l-7.42 7.43 7.42 7.42a.75.75 0 0 1-1.06 1.061l-7.95-7.95a.75.75 0 0 1 0-1.06l7.95-7.96a.75.75 0 0 1 1.06 0Z",
  fill: "#0C1120"
})));
export default SvgIcBack24X24;